/*
  dzc-card.js — binds the product card's boxed "+" to the Quick View modal.

  Every surface that renders dzc-product-card calls:
    DzcCard.init(rootElement)
  and the "+" on any card inside that root opens the shared modal
  (snippets/dzc-quickview-modal.liquid) for that card's product. Cards may
  be injected into the root later — the delegation survives that.

  There is deliberately NO variant logic here any more. The modal renders
  the product's real options and its own add-to-cart, so a product can't
  be added without an explicit choice on every axis. The collection page's
  size FILTER is separate and lives in that section's own script.

  init() takes an optional second argument for backwards compatibility
  with surfaces that still pass their size getter; it is unused.
*/
window.DzcCard = window.DzcCard || (function () {
  /* Every card surface renders the shared runtime, so a page with several
     rails ends up with several Quick View shells. Only the first is ever
     wired, so drop the rest — cheaper than leaving dead markup around.
     (Rendering the modal once from layout/theme.liquid removes the need.) */
  function dedupeModals() {
    var shells = document.querySelectorAll('[data-qv-back]');
    for (var i = 1; i < shells.length; i++) {
      if (shells[i].parentNode) shells[i].parentNode.removeChild(shells[i]);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', dedupeModals);
  else dedupeModals();

  function init(root) {
    if (!root || root.dataset.dzcCardBound === '1') return;
    root.dataset.dzcCardBound = '1';

    root.addEventListener('click', function (e) {
      var qa = e.target.closest('[data-dzc-qa]');
      if (!qa) return;
      e.preventDefault();
      var card = qa.closest('[data-dzc-card]');
      if (!card) return;
      var handle = card.getAttribute('data-handle');
      if (window.DzcQuickView && handle) {
        window.DzcQuickView.open(handle);
      } else if (card.getAttribute('data-url')) {
        window.location.href = card.getAttribute('data-url');   /* modal missing: never dead-end */
      }
    });
  }

  return { init: init };
})();
